<div class="search-bar" id="zoom">
    <div class="ui fluid search teal" id="search">
        <p class="hide-on-mobile">Who should I invite to the meeting?</p>
        <div class="ui icon fluid input" [ngClass]="{ disabled: !wizardService.taskMetaData.isAllowedApp }">
            <input
                class="prompt"
                type="text"
                placeholder="Add guests by name, email or team"
                [(ngModel)]="query"
                (keyup)="handleKeyup()"
            />
            <div *ngIf="showLoadingIndicator" class="loading-message">
                <span class="long"> Hang tight, your search results are loading... </span>
                <span class="short"> Loading search results... </span>
            </div>
            <i class="search icon"></i>
        </div>
        <div class="results"></div>
    </div>
    <ng-container *ngIf="isPlugin">
        <ng-container *ngIf="selection$ | async as selection">
            <div *ngIf="selection.length > 0" class="search-bar__selection">
                <div class="ui label" *ngFor="let contact of selection; trackBy: trackSelection">
                    {{ contact.name || contact.defaultEmail || contact.email[0] }}
                    <i class="delete icon" (click)="handleRemoveContact(contact.id)"></i>
                </div>
            </div>
        </ng-container>
        <div class="search-bar__add-contact" *ngIf="eventService.isAddingContact">
            <zoom-new-contact-card
                (onAdd)="handleAddContact($event)"
                (onClose)="handleCloseAddContact()"
                [isLoading]="isAddingContact"
                [isPlugin]="isPlugin"
            ></zoom-new-contact-card>
        </div>
    </ng-container>
</div>
